interface EnvironmentConfig {
	/** 后端地址 */
	A1_JS_URL: string;
	/** 后端地址 */
	A1_SERVER_URL: string;
	/** 静态资源地址 */
	A1_STATIC_URL: string;
	/** 套接字地址 */
	A1_SOCKET_URL: string;
	/** 谷歌客户端ID */
	GOOGLE_CLIENT_ID: string;
	/** 数据仓库地址 */
	A1_DATA_WAREHOUSE: string;
	/** Facebook App ID */
	FACEBOOK_APP_ID: string;
	/** 云控制回退地址 */
	CLOUD_CTRL_FALLBACK_URL: string;
}
export enum DeployEnvironment {
	tencent = 'a1-tencent-test',
	zprod = 'a1-tencent-zprod',
}

// 创建配置对象
export const ENV_CONFIG: Record<DeployEnvironment, EnvironmentConfig> = {
	[DeployEnvironment.tencent]: {
		A1_JS_URL: 'https://itest.a1aws.geesdev.com',
		A1_SERVER_URL: 'https://itest.a1aws.geesdev.com',
		A1_SOCKET_URL: 'https://itest.a1aws.geesdev.com',
		A1_STATIC_URL: 'https://txcdn-test-a1art.xiaopiu.com',
		// a1 web端google 登录 id，不要改
		GOOGLE_CLIENT_ID: '141344069073-6e70fomdg7nrjmafp8kcbhbnpo021bq4.apps.googleusercontent.com',
		A1_DATA_WAREHOUSE: 'https://aws-test-data.geesdev.com',
		FACEBOOK_APP_ID: '1138073627168453',
		CLOUD_CTRL_FALLBACK_URL: 'https://a1aws.geesdev.com/fe/configData',
	},
	[DeployEnvironment.zprod]: {
		A1_JS_URL: 'https://popdoll.app.a1.art',
		A1_SERVER_URL: 'https://popdoll.app.a1.art',
		A1_STATIC_URL: 'https://txcdn-prod-a1art.xiaopiu.com',
		A1_SOCKET_URL: 'wss://popdoll.app.a1.art',
		// a1 web端google 登录 id，不要改
		GOOGLE_CLIENT_ID: '276705988881-d65vifdc3mcj9182ai0oth9fsuva5pr4.apps.googleusercontent.com',
		A1_DATA_WAREHOUSE: 'https://data.a1.art',
		FACEBOOK_APP_ID: '1138073627168453',
		CLOUD_CTRL_FALLBACK_URL: 'https://a1.art/fe/configData',
	},
};

export default ENV_CONFIG;

export function getCurrentDeploy(deployEnv: DeployEnvironment) {
	return Object.values(DeployEnvironment).includes(deployEnv)
		? deployEnv
		: (() => {
				throw new Error('deployEnv is not valid');
			})();
}
